export default "__VITE_ASSET__Cb9POFo5__"